var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#6685FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L12.2839 11.7143C12.51 11.4939 12.6902 11.2283 12.8133 10.9335C12.9365 10.6387 13 10.321 13 10C13 9.679 12.9365 9.36126 12.8133 9.06649C12.6902 8.77171 12.51 8.50609 12.2839 8.28571L8 4",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRight);
export default __webpack_public_path__ + "static/media/Active-Right.44baf1256e38ba5b23d849565724eddc.svg";
export { ForwardRef as ReactComponent };